import React from 'react';
import { Logo } from '../../../icons/components';
import { Container } from '../../shared/Container';

export const Header = () => {
    function getLogoUtmLink() {
        const path = window.location.pathname;
        let url = '';

        if (path.includes('bedankt')) return '/';
        //if (path.includes('afspraak')) return 'https://www.hypotheker.nl/';

        if (path.includes('fundamliapp')) {
            url =
                '/?utm_source=Funda&utm_medium=Webvertising&utm_content=Bannerlink_MLI_App&utm_campaign=7011v000000KF1pAAG';
        } else if (path.includes('fundamlimobile')) {
            url =
                '/?utm_source=Funda&utm_medium=Webvertising&utm_content=Bannerlink_MLI_Mweb&utm_campaign=7011v000000KF1kAAG';
        }

        if (path.includes('goudadesktop')) {
            url = '/?utm_source=westergouwe&utm_medium=calculator&utm_content=desktop';
        } else if (path.includes('goudamobile')) {
            url = 'utm_source=westergouwe&utm_medium=calculator&utm_content=mobile';
        }

        if (path.includes('huislijnmlidesktop')) {
            url =
                '/?utm_source=huislijn&utm_medium=Webvertising&utm_content=Bannerlink_MLI&utm_campaign=MCMPCA1C5B284A6B09856FF10AE1DD3954';
        } else if (path.includes('huislijnmlimobile')) {
            url =
                '/?utm_source=huislijn&utm_medium=Webvertising&utm_content=Bannerlink_MLI_Mweb&utm_campaign=MCMPCA1C5B284A6B09856FF10AE1DD3954';
        }

        if (path.includes('huispediamlidesktop')) {
            url =
                '/?utm_source=huispedia&utm_medium=webvertising&utm_content=Bannerlink_MLI&utm_campaign=70107000000PgCCAA0';
        } else if (path.includes('huispediamlimobile')) {
            url =
                '/?utm_source=huispedia&utm_medium=webvertising&utm_content=Bannerlink_MLI_Mweb&utm_campaign=70107000000PgCCAA0';
        }

        if (path.includes('jaapmlidesktop')) {
            url =
                '/?utm_source=jaap&utm_medium=webvertising&utm_content=Bannerlink_MLI&utm_campaign=70107000000Pg3IAAS';
        } else if (path.includes('jaapmlimobile')) {
            url =
                '/?utm_source=jaap&utm_medium=webvertising&utm_content=Bannerlink_MLI_Mweb&utm_campaign=70107000000Pg3DAAS';
        }

				if (path.includes('huizenzoekermlidesktop')) {
					url = '/?utm_source=huizenzoeker&utm_medium=webvertising&utm_content=Bannerlink_MLI&utm_campaign=701070000016sgBAAQ'
				} else if (path.includes('huizenzoekermlimobile')) {
					url = '/?utm_source=huizenzoeker&utm_medium=webvertising&utm_content=Bannerlink_MLI_Mweb&utm_campaign=701070000016sg6AAA';
				}

        if (path.includes('mhzmlidesktop')) {
            return '/?utm_source=jaap&utm_medium=webvertising&utm_content=Bannerlink_MLI&utm_campaign=70107000000PpxDAAS';
        } else if (path.includes('mhzmlimobile')) {
            return '/?utm_source=jaap&utm_medium=webvertising&utm_content=Bannerlink_MLI_Mweb&utm_campaign=70107000000Ppx8AAC';
        }

        return url;
    }

    return (
        <header className="c-header">
            <Container extraClass="header__container">
                <a className="header__logo" rel="noopener noreferrer" href={getLogoUtmLink()} target={'_blank'}>
                    <Logo height={52} width={172} />
                </a>
            </Container>
        </header>
    );
};
